export function scrollToId(id: string, offsetPx = 0) {
  const el = document.getElementById(id);
  if (!el) return;

  const top = el.getBoundingClientRect().top + window.scrollY - offsetPx;

  window.scrollTo({
    top,
    behavior: 'smooth',
  });
}